import { render, staticRenderFns } from "./pagePopup.vue?vue&type=template&id=4eb3630c&scoped=true&"
import script from "./pagePopup.vue?vue&type=script&lang=js&"
export * from "./pagePopup.vue?vue&type=script&lang=js&"
import style0 from "./pagePopup.vue?vue&type=style&index=0&id=4eb3630c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb3630c",
  null
  
)

export default component.exports